module.exports = __webpack_public_path__ + "static/img/share.5855b4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/7/share.png
// module id = TVER
// module chunks = 0